/**
 * Collection Personalize — reorder product grid to feature a specific product first.
 * Reads ?product=<handle> from URL (or sessionStorage fallback) via NDPersonalization utils.
 *
 * Initial reorder is handled by an inline <script> in the Liquid template
 * (runs synchronously before first paint, preventing FOUC).
 * This deferred script handles:
 *   - sessionStorage persistence of the product handle
 *   - MutationObserver to re-apply reorder after facets.js replaces the grid HTML
 *   - Fetching the product card via Section Rendering API when not on current page
 */
(function () {
  'use strict';

  if (typeof NDPersonalization === 'undefined') return;

  // Only personalize on page 1 (or no page param = page 1)
  var pageParam = new URLSearchParams(window.location.search).get('page');
  if (pageParam && pageParam !== '1') return;

  var handle = NDPersonalization.getProductHandle(window.location.pathname);
  if (!handle) return;

  if (new URLSearchParams(window.location.search).get('product')) {
    NDPersonalization.storeProductHandle(window.location.pathname, handle);
  }

  var cachedCardHTML = null;
  var fetchInProgress = false;

  function applyFeaturedStyles(item) {
    item.setAttribute('data-featured', 'true');
    var img = item.querySelector('img');
    if (img && img.loading === 'lazy') img.loading = 'eager';
  }

  function injectCachedCard(grid) {
    if (!cachedCardHTML) return false;
    var temp = document.createElement('div');
    temp.innerHTML = cachedCardHTML;
    var li = temp.firstElementChild;
    if (!li) return false;
    grid.insertBefore(li, grid.firstElementChild);
    applyFeaturedStyles(li);
    return true;
  }

  function fetchProductCard() {
    if (fetchInProgress) return;
    fetchInProgress = true;

    fetch('/products/' + handle + '?section_id=product-card-personalization')
      .then(function (res) { return res.ok ? res.text() : null; })
      .then(function (html) {
        fetchInProgress = false;
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var li = doc.querySelector('li.grid__item');
        if (!li || li.getAttribute('data-product-handle') !== handle) return;
        cachedCardHTML = li.outerHTML;
        var currentGrid = document.getElementById('product-grid');
        if (currentGrid) {
          var first = currentGrid.querySelector('li.grid__item');
          if (!first || first.getAttribute('data-product-handle') !== handle) {
            injectCachedCard(currentGrid);
          }
        }
      })
      .catch(function () { fetchInProgress = false; });
  }

  function reorderGrid() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;

    // Skip if already reordered (by inline script or previous observer call)
    var first = grid.querySelector('li.grid__item');
    if (first && first.getAttribute('data-product-handle') === handle) return;

    var matchedItem = NDPersonalization.reorderByHandle(grid, 'li.grid__item', handle);
    if (matchedItem) {
      applyFeaturedStyles(matchedItem);
      return;
    }

    // Product not in current page — try cached card, then fetch via Section Rendering API
    if (injectCachedCard(grid)) return;
    fetchProductCard();
  }

  // Initial call: fetch product from other pages if inline script couldn't find it on page 1
  reorderGrid();

  // Re-apply after facets.js replaces the grid HTML (inline script only runs once at parse time)
  var gridContainer = document.getElementById('ProductGridContainer');
  if (gridContainer) {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].type === 'childList') {
          cachedCardHTML = null;
          fetchInProgress = false;
          reorderGrid();
          break;
        }
      }
    });
    observer.observe(gridContainer, { childList: true, subtree: false });
  }
})();
